var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","color":(_vm.isActive && _vm.isActive()) ? 'primary': '',"title":_vm.title},on:{"click":_vm.action}},[_c('v-icon',[_vm._v("mdi-"+_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }